import { render, staticRenderFns } from "./keyInspectionRecord.vue?vue&type=template&id=9b01d8bc&"
import script from "./keyInspectionRecord.vue?vue&type=script&lang=js&"
export * from "./keyInspectionRecord.vue?vue&type=script&lang=js&"
import style0 from "./keyInspectionRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports